import api from "../js/axios";

export const WebService = {
    getBlog: async () => {
        const response = await api.get('/web/getBlog');
        return response.data;
    },
    getBlogByID: async (blog_id) => {
        const response = await api.get(`/web/getBlogByID/${blog_id}`);
        return response.data;
    },
    getBlogHome: async () => {
        const response = await api.get('/web/getBlogHome');
        return response.data;
    },
    getCuestionario: async (id) => {
        const response = await api.get(`/web/getCuestionario/${id}`);
        return response.data;
    },
    getCursos: async (nominaID) => {
        const response = await api.get(`/web/getCursos/${nominaID}`);
        return response.data;
    },
};